import moment from 'moment';
import getArrayTrueElementsCount from './getArrayTrueElementsCount';
import getFormData from './getFormData';
import { PHOTOS_COUNT } from './constants';
import isValidDate from './isValidDate';
import checkCoordinates from './checkCoordinates';
import {
  buildHoldingDatesListPayload,
  isValidHoldingTime,
} from './formatHoldingDatesList';
import { validateCardLanguages } from './interfaceLanguages';
import { splitCarouselPhotos } from './photoUrls';

function checkAddEventPayload({
  owner_id,
  name,
  country_id,
  city_id,
  address,
  coordinates,
  holding_dates,
  holding_time,
  date_start,
  date_end,
  contacts,
  description,
  photos,
  withPhotos = true,
  events_category_id,
  is_in_all_cities_of_country = false,
  allow_missing_holding_dates = false,
  languages = [],
  is_for_all_languages = true,
}) {
  const errors = [];
  const isInAllCities = Boolean(is_in_all_cities_of_country);
  const isForAllLanguages = Boolean(is_for_all_languages);

  if (owner_id?.length !== 24) {
    errors.push(' * неправильный формат ID пользователя (24 символа)');
  }
  if (name.length < 2) {
    errors.push(' * название не меньше 2 символов');
  } else if (name.length > 100) {
    errors.push(' * название не больше 100 символов');
  }
  if (!events_category_id) {
    errors.push(' * не выбрана категория события');
  }

  const holding_dates_list = buildHoldingDatesListPayload(holding_dates, holding_time);
  if (!holding_dates_list.length && !allow_missing_holding_dates) {
    errors.push(' * укажите хотя бы одну дату проведения');
  }
  if (holding_time && !isValidHoldingTime(holding_time)) {
    errors.push(' * время в формате ЧЧ:ММ (например 18:30)');
  }

  if (isInAllCities) {
    if (!country_id) {
      errors.push(' * не выбрана страна');
    }
  } else if (city_id) {
    if (address.length < 2) {
      errors.push(' * адрес не меньше 2 символов');
    }
    if (!checkCoordinates(coordinates?.lat, coordinates?.lon)) {
      errors.push(' * не валидные координаты');
    }
  } else {
    errors.push(' * не выбран город');
  }
  if (getArrayTrueElementsCount(Object.values(contacts)) < 1) {
    errors.push(' * укажите хотя бы один из методов контакта с вами');
  }
  if (description.length < 2) {
    errors.push(' * описание не меньше 2 символов');
  }
  const languagesError = validateCardLanguages({
    languages,
    isForAllLanguages,
  });
  if (languagesError) {
    errors.push(` * ${languagesError}`);
  }
  const { files: filePhotos, urls: photoUrls } = splitCarouselPhotos(photos);
  const photoTotal = filePhotos.length + photoUrls.length;
  if (withPhotos && photoTotal < PHOTOS_COUNT.carouselMin) {
    errors.push(` * выберите хотя бы ${PHOTOS_COUNT.carouselMin} фото`);
  } else if (withPhotos && photoTotal > 15) {
    errors.push(' * выберите не больше 15 фото');
  }

  if (errors.length) {
    return { errors };
  }

  const payload = {
    owner_id,
    name,
    country_id,
    contacts,
    description,
    events_category_id,
    is_in_all_cities_of_country: isInAllCities,
    languages_ids: (languages || []).map((item) => item._id),
    is_for_all_languages: isForAllLanguages,
  };

  if (holding_dates_list.length) {
    payload.holding_dates_list = holding_dates_list;
  }

  if (!isInAllCities) {
    payload.city_id = city_id;
    payload.address = address;
  }

  if (isValidDate(new Date(date_start))) payload.date_start = moment.utc(date_start, 'YYYY-MM-DD').startOf('day').toISOString();
  if (isValidDate(new Date(date_end))) payload.date_end = moment.utc(date_end, 'YYYY-MM-DD').startOf('day').toISOString();

  if (!isInAllCities && city_id) {
    payload.lat = coordinates?.lat ? coordinates.lat.toString() : '0';
    payload.lon = coordinates?.lon ? coordinates.lon.toString() : '0';
    payload.is_special_point_on_map = Boolean(coordinates?.is_special_point_on_map);
  }
  if (withPhotos) {
    const formData = getFormData(payload, [
      ...filePhotos,
      ...photoUrls.map((url) => ({ url })),
    ]);
    return { formData };
  }
  return { payload };
}

export default checkAddEventPayload;
